export function videoLinkKey(value) {
  try {
    const url = new URL(value);
    if (!['http:', 'https:'].includes(url.protocol)) return '';
    const host = url.hostname.toLowerCase();
    const youtube = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host);
    const id = host === 'youtu.be' ? url.pathname.split('/')[1]
      : youtube ? (url.searchParams.get('v') || (/^\/(?:embed|shorts|live)\/([^/]+)/.exec(url.pathname)?.[1])) : null;
    if (id && /^[\w-]{11}$/.test(id)) return `youtube:${id}`;
    url.hash = '';
    return url.href;
  } catch { return ''; }
}
